import React, {useRef} from 'react';
import {OrbitControls, TrackballControls} from '@react-three/drei';
import {useFrame} from '@react-three/fiber';

const cloneControlsTarget = (from, to) => {
  if (!from || !to) return;
  const target = from.target;
  //@ts-expect-error update() is private
  from.update();
  to.target.set(target.x, target.y, target.z);
  // @ts-expect-error update() is private
  to.update();
};

const CameraControls = () => {
  const orbitControlsRef = useRef(null);
  const trackballControlsRef = useRef(null);

  //#region Executed each frame

  //Clone OrbitControls target to TrackballControls
  useFrame(() => {
    // @ts-ignore
    cloneControlsTarget(orbitControlsRef.current, trackballControlsRef.current);
  });

  //#endregion

  return (
    <>
      {/*@ts-ignore*/}
      <OrbitControls ref={orbitControlsRef}
                     enablePan={false}
                     enableRotate={true}
                     enableZoom={false}
                     enabled={true}
                     enableDamping={true}
                     makeDefault={true}
                     maxPolarAngle={100 * Math.PI / 180}
      />
      {/*@ts-ignore*/}
      <TrackballControls ref={trackballControlsRef}
                         noPan={true}
                         noRotate={true}
                         noZoom={false}
                         enabled={true}
                         staticMoving={false}
                         zoomSpeed={.5} // default 1.2
                         minDistance={2}
                         maxDistance={12}
                         dynamicDampingFactor={0.1} // default 0.2
      />
      {/*@ts-ignore*/}
      {/*<CameraShake yawFrequency={0.05} rollFrequency={0.2} pitchFrequency={0.1} />*/}
    </>
  );
};

export default CameraControls;
